import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {flex, flexDirection, mb, minWidth, mr, onDesktop, ph, pv, w25, w100} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {InfoIconWithPopover} from "./InfoIconWithPopover";

export enum MainDataType {
    PERCENT,
    COMMISSION,
    INSTALLMENT,
    RRSO
}

export interface IMainDataProps {
    fixedInterestPercent: number;
    commission: number;
    equalInstallmentRate: number;
    rrso: number;
}

export const CreditOfferBoxMainData = (props: IMainDataProps) => {
    const {fixedInterestPercent, commission, equalInstallmentRate, rrso} = props;
    const theme = useTheme();

    return (
        <div css={mainDataWrapper}>
            <div css={mainDataHolder}>
                <div css={[flex("center", "start"), flexDirection("row"), mb(0.5)]}>
                    <Text variant="body_copy_2" color={theme.colors.gray[600]} css={mr(0.5)}>
                        Oprocentowanie
                    </Text>
                    <InfoIconWithPopover type={MainDataType.PERCENT} />
                </div>
                <Text as="p" variant="headline_2" css={dataTextStyle}>
                    {numberFormat(fixedInterestPercent, {precision: 2, unit: "%", unitZero: "0%"})}
                    <Text as="span" variant="info_txt_2" strong css={[ph(2)]}>
                        Stałe
                    </Text>
                </Text>
            </div>

            <div css={mainDataHolder}>
                <div css={[flex("center", "start"), flexDirection("row"), mb(0.5)]}>
                    <Text variant="body_copy_2" color={theme.colors.gray[600]} css={mr(0.5)}>
                        RRSO
                    </Text>

                    <InfoIconWithPopover type={MainDataType.RRSO} />
                </div>
                <Text as="p" variant="headline_2" css={dataTextStyle}>
                    {numberFormat(rrso, {precision: 2, unit: "%", unitZero: "0%"})}
                </Text>
            </div>

            <div css={mainDataHolder}>
                <div css={[flex("center", "start"), flexDirection("row"), mb(0.5)]}>
                    <Text variant="body_copy_2" color={theme.colors.gray[600]} css={mr(0.5)}>
                        Prowizja
                    </Text>

                    <InfoIconWithPopover type={MainDataType.COMMISSION} />
                </div>
                <Text as="p" variant="headline_2" css={dataTextStyle}>
                    {numberFormat(commission, {precision: 2, unit: "%", unitZero: "0%"})}
                </Text>
            </div>

            <div css={mainDataHolder}>
                <div css={[flex("center", "start"), flexDirection("row"), mb(0.5)]}>
                    <Text variant="body_copy_2" color={theme.colors.gray[600]} css={mr(0.5)}>
                        Rata miesięczna
                    </Text>

                    <InfoIconWithPopover type={MainDataType.INSTALLMENT} />
                </div>
                <Text as="p" variant="headline_2" css={dataTextStyle}>
                    <Highlight>
                        {Math.round(equalInstallmentRate)}{" "}
                        <Text as="span" variant="headline_6">
                            zł
                        </Text>
                    </Highlight>
                </Text>
            </div>
        </div>
    );
};

const mainDataWrapper = css`
    ${flex("start", "space-evenly")};
    ${flexDirection("column")};
    ${mb(2)};

    ${onDesktop(flexDirection("row"))};

    & > div:last-child {
        border-bottom: unset;
        border-right: unset;
    }
`;

const dataTextStyle = css`
    ${flex("center", "start")};
    ${minWidth("130px")};
`;

const mainDataHolder = (theme: Theme) => css`
    ${flex("end", "space-between")};
    ${w100};
    border-bottom: 1px solid ${theme.colors.gray[500]};
    ${pv(1)};

    ${onDesktop(css`
        ${flex("start", "space-between")};
        ${flexDirection("column")};
        ${w25};
        ${mr(3)};
        border-right: 1px solid ${theme.colors.gray[500]};
        border-bottom: unset;
    `)};
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {flex, flexDirection, mb, minWidth, mr, onDesktop, ph, pv, w25, w100} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {InfoIconWithPopover} from "./InfoIconWithPopover";

export enum MainDataType {
    PERCENT,
    COMMISSION,
    INSTALLMENT,
    RRSO
}

export interface IMainDataProps {
    fixedInterestPercent: number;
    commission: number;
    equalInstallmentRate: number;
    rrso: number;
}

export const CreditOfferBoxMainData = (props: IMainDataProps) => {
    const {fixedInterestPercent, commission, equalInstallmentRate, rrso} = props;
    const theme = useTheme();

    return (
        <div css={mainDataWrapper}>
            <div css={mainDataHolder}>
                <div css={[flex("center", "start"), flexDirection("row"), mb(0.5)]}>
                    <Text variant="body_copy_2" color={theme.colors.gray[600]} css={mr(0.5)}>
                        Oprocentowanie
                    </Text>
                    <InfoIconWithPopover type={MainDataType.PERCENT} />
                </div>
                <Text as="p" variant="headline_2" css={dataTextStyle}>
                    {numberFormat(fixedInterestPercent, {precision: 2, unit: "%", unitZero: "0%"})}
                    <Text as="span" variant="info_txt_2" strong css={[ph(2)]}>
                        Stałe
                    </Text>
                </Text>
            </div>

            <div css={mainDataHolder}>
                <div css={[flex("center", "start"), flexDirection("row"), mb(0.5)]}>
                    <Text variant="body_copy_2" color={theme.colors.gray[600]} css={mr(0.5)}>
                        RRSO
                    </Text>

                    <InfoIconWithPopover type={MainDataType.RRSO} />
                </div>
                <Text as="p" variant="headline_2" css={dataTextStyle}>
                    {numberFormat(rrso, {precision: 2, unit: "%", unitZero: "0%"})}
                </Text>
            </div>

            <div css={mainDataHolder}>
                <div css={[flex("center", "start"), flexDirection("row"), mb(0.5)]}>
                    <Text variant="body_copy_2" color={theme.colors.gray[600]} css={mr(0.5)}>
                        Prowizja
                    </Text>

                    <InfoIconWithPopover type={MainDataType.COMMISSION} />
                </div>
                <Text as="p" variant="headline_2" css={dataTextStyle}>
                    {numberFormat(commission, {precision: 2, unit: "%", unitZero: "0%"})}
                </Text>
            </div>

            <div css={mainDataHolder}>
                <div css={[flex("center", "start"), flexDirection("row"), mb(0.5)]}>
                    <Text variant="body_copy_2" color={theme.colors.gray[600]} css={mr(0.5)}>
                        Rata miesięczna
                    </Text>

                    <InfoIconWithPopover type={MainDataType.INSTALLMENT} />
                </div>
                <Text as="p" variant="headline_2" css={dataTextStyle}>
                    <Highlight>
                        {Math.round(equalInstallmentRate)}{" "}
                        <Text as="span" variant="headline_6">
                            zł
                        </Text>
                    </Highlight>
                </Text>
            </div>
        </div>
    );
};

const mainDataWrapper = css`
    ${flex("start", "space-evenly")};
    ${flexDirection("column")};
    ${mb(2)};

    ${onDesktop(flexDirection("row"))};

    & > div:last-child {
        border-bottom: unset;
        border-right: unset;
    }
`;

const dataTextStyle = css`
    ${flex("center", "start")};
    ${minWidth("130px")};
`;

const mainDataHolder = (theme: Theme) => css`
    ${flex("end", "space-between")};
    ${w100};
    border-bottom: 1px solid ${theme.colors.gray[500]};
    ${pv(1)};

    ${onDesktop(css`
        ${flex("start", "space-between")};
        ${flexDirection("column")};
        ${w25};
        ${mr(3)};
        border-right: 1px solid ${theme.colors.gray[500]};
        border-bottom: unset;
    `)};
`;
